export default function parseMoney(money: string | number | undefined) {
    if (money === undefined) return '-'
    const stringMoney = typeof money === 'number' ? String(money) : money
    return stringMoney === '0' ? 'R$ 0,00' : 'R$ ' + stringMoney.replace('.', ',')
}

export function parseMoneyExam(money: string | number | undefined) {
    if (money === undefined) return '-'
    var stringMoney = 'R$ 0,00'

    if(typeof money === 'number') {
        stringMoney =  String(Number(money.toString()).toFixed(2))
    } else {
        stringMoney = money
    }

    return stringMoney === '0' ? 'R$ 0,00' : 'R$ ' + stringMoney.replace('.', ',')
}